/* tslint:disable */
/* eslint-disable */
/**
 * React-app-base API
 * API react-app-base
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */
export enum NastaveniStatus {
    OK = 'OK',
    REFRESH = 'REFRESH'
}



